import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-loading-shade',
    templateUrl: './loading-shade.component.html',
    styleUrls: ['./loading-shade.component.scss'],
    standalone: false
})
export class LoadingShadeComponent {
  @Input()
  isLoading = false;
}
